import { render, staticRenderFns } from "./LoadingMask.vue?vue&type=template&id=72c744a7&scoped=true&"
import script from "./LoadingMask.vue?vue&type=script&lang=js&"
export * from "./LoadingMask.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMask.vue?vue&type=style&index=0&id=72c744a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c744a7",
  null
  
)

export default component.exports